import { render } from "./OrderContainersTable.vue?vue&type=template&id=20556fc1&scoped=true&ts=true"
import script from "./OrderContainersTable.vue?vue&type=script&lang=ts"
export * from "./OrderContainersTable.vue?vue&type=script&lang=ts"

import "./OrderContainersTable.vue?vue&type=style&index=0&id=20556fc1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20556fc1"]])

export default __exports__